<template>
    <el-container>
        <el-header>
          <div class="logodiv" style="height: 95px"><img alt="" src="static/lablogo.jpg" width="100%"></div> <div class="regdiv"><span class="logout" @click="onLogout"><i class="el-icon-unlock"></i> 注销[实验老师]</span></div>
        </el-header>
        <el-main>
          <div class="cardrow">
            <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
              <el-menu-item index="1">实验首页</el-menu-item>
              <el-menu-item index="2"><router-link to="/gaoya/hall" style="text-decoration: none;">仿真实验</router-link></el-menu-item>
              <el-menu-item index="3"><router-link to="/gaoya/upgrade" style="text-decoration: none;">下载升级</router-link></el-menu-item>
              <el-menu-item index="4"><router-link to="/gaoya/teach" style="text-decoration: none;">教学情况</router-link></el-menu-item>
              <el-menu-item index="5"><router-link to="/gaoya/person" style="text-decoration: none;">用户中心</router-link></el-menu-item>
            </el-menu>
          </div>
          <div><img alt="" src="static/xlabbanner.jpg"></div>
          <div class="cardrow" style="text-align: left;">
            <span><el-tag effect="dark">系统环境要求</el-tag></span>
            <el-divider content-position="right">ENVIRONMENT REQUIREMENT</el-divider>
            <el-table
              :data="itemTableData"
              stripe
              style="width: 100%">
              <el-table-column
                prop="itemIdx"
                label="需求序号"
                width="100">
              </el-table-column>
              <el-table-column
                prop="itemDesc"
                label="系统需求">
              </el-table-column>
              <el-table-column
                  fixed="right"
                  label="备注说明"
                  width="100">
              </el-table-column>
            </el-table>
            <span><el-tag effect="dark">实验操作说明</el-tag></span>
            <el-divider content-position="left">INTRODUCTION EXPERIMENT</el-divider>
            <el-table
              :data="tableData"
              stripe
              style="width: 100%">
              <el-table-column
                prop="stepIdx"
                label="步骤序号"
                width="100">
              </el-table-column>
              <el-table-column
                prop="stepDesc"
                label="步骤描述">
              </el-table-column>
              <el-table-column
                  fixed="right"
                  label="下载区域"
                  width="100">
                  <template slot-scope="scope">
                    <el-button @click="handleClick(scope.$index)" type="text" size="small">下载</el-button>
                  </template>
              </el-table-column>
            </el-table>
          </div>
        </el-main>
        <el-footer>
          <el-divider></el-divider>
          系统集成与技术支持：湖南湘交高创信息技术有限公司 
          <el-rate
            v-model="rate"
            disabled
            show-score
            text-color="#ff9900"
            score-template="{value}">
          </el-rate>
        </el-footer>
    </el-container>
</template>


<script>
import axios from '@/assets/axios';

export default {
  data () {
    return {
      activeIndex: '1',
      currentDate: new Date(),
      rate: 3.9,
      tableData: [
        {
          stepIdx: '(1)',
          stepDesc: '首次运行虚拟实验前，请先通过下载链接下载安装运行环境。点击下载区下载并安装运行环境。',
        }, {
          stepIdx: '(2)',
          stepDesc: '运行环境安装完毕后，点击“开始实验”后，自动加载运行虚拟实验。',
        }, {
          stepIdx: '(3)',
          stepDesc: 'Win10操作系统如果无法打开实验，请检查本机是否启用了.NET Framework 3.5功能，点击下载区安装程序查看启用功能。',
        }, {
          stepIdx: '(4)',
          stepDesc: 'Win7及XP系统如果无法打开实验，请点击下载区下载安装包。',
        },{
          stepIdx: '(5)',
          stepDesc: '浏览器兼容性: 谷歌Chrome 60.0 以上, 火狐 Firefox-55.0以上, 360浏览器(极速模式)，QQ浏览器(极速模式), 搜狗浏览器(高速模式)等。',
        }
      ],
      itemTableData: [
        {
          itemIdx: '(1)',
          itemDesc: '微型计算机：Intel 酷睿 I5，双核 CPU，4G 内存，250G 硬盘，独立显卡 512M 显存，17 英寸液晶显示器，安装 Windows 7 及以上的系统。 '
        },
        {
          itemIdx: '(2)',
          itemDesc: '安装电力变压器高电压绝缘仿真软件 Lianapac。'
        }
      ]

    }
  },
  beforeMount:function(){
    if (!sessionStorage.getItem('user')){
      this.$router.push({path: "/gaoya/login"});
    }
  },
  mounted:function(){
    if (!sessionStorage.getItem("checked")) { 
      const loading = this.$loading({
          lock: true,
          text: '系统检查中..',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
          loading.close();
        }, 5000);
        /*
        setTimeout(() => {
          this.$message('网络检查正常');
        }, 1000);
        setTimeout(() => {
          this.$message('系统版本检查正常');
        }, 2500);
        setTimeout(() => {
          this.$message('清空临时存储空间');
        }, 3000);
        */
       const that = this;
       axios.get('https://wx.hnjt.edu.cn/payinvoiceapp/xlab/getdata', {
         params: {
           code: "1"
         }
       })
        .then(function (response) {
          if (response.status == 200) {
            that.$message('网络检查正常');
          }
        })
        .catch(function (error) {
          console.log(error);
        });
        axios.get('https://wx.hnjt.edu.cn/payinvoiceapp/xlab/getdata', {
         params: {
           code: "2"
         }
       })
        .then(function (response) {
          if (response.status == 200) {
            that.$message('系统版本检查正常');
          }
        })
        .catch(function (error) {
          console.log(error);
        });
        axios.get('https://wx.hnjt.edu.cn/payinvoiceapp/xlab/getdata', {
         params: {
           code: "3"
         }
       })
        .then(function (response) {
          if (response.status == 200) {
            that.$message('清空临时存储空间');
          }
        })
        .catch(function (error) {
          console.log(error);
        });
      sessionStorage.setItem("checked", "1");
    }      
  },
  methods: {
    onLogout() {
      this.$confirm('注销将清空实验操作空间, 操作结果是否已上传?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          sessionStorage.removeItem("checked");
          this.$router.push({path: "/"});
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });          
        });
      
    },
    handleSelect() {

    },
    handleClick(e) {
      if (e === 0 || e === 2 || e === 3){
        this.$message.error('临时空间不足');
      }else{
        this.$message({
          message: '该步骤无下载项',
          type: 'success'
        });
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .el-header {
    /* background-color: #B3C0D1; */
    color: #333;
    text-align: center;
    line-height: 95px;
    height: 95px !important; 
  }

  .el-footer {
    text-align: center;
    line-height: 35px;
  }
  
  .el-main {
    /* background-color: #0068B7; */
    /* color: #333; */
    text-align: center;
    /* line-height: 160px; */
    width: 100%;
    /* height: 50vh; */
    padding: 0;
    overflow: hidden;
  }

  .logodiv {
    float: left;
    margin-left: 10%;
  }

  .regdiv {
    float: right;
    margin-right: 10%;
  }

  .logout {
    color: #0068B7;
  }

  .logout:hover {
    cursor: pointer;
  }

  .cardrow {
    width: 60%;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/GaoYa/LabIndex.vue